import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/firestore";

export const firebaseConfig = {
    apiKey: "AIzaSyCr0FlyfWg5AWvH6QDll51IfLinOw2hch8",
    authDomain: "steps-c4a79.firebaseapp.com",
    databaseURL: "https://steps-c4a79.firebaseio.com",
    projectId: "steps-c4a79",
    storageBucket: "steps-c4a79.appspot.com",
    messagingSenderId: "459328783316",
    appId: "1:459328783316:web:2f2000189ed5347dce0c41",
    measurementId: "G-TP6NCGLC3V",
};
export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.firestore();
export const storage = firebaseApp.storage();
export const auth = firebaseApp.auth();